export function unwrapPagedList<T>(raw: unknown): T[] {
  if (Array.isArray(raw)) return raw as T[];
  if (raw && typeof raw === 'object' && Array.isArray((raw as { Data?: unknown }).Data)) {
    return (raw as { Data: T[] }).Data;
  }
  return [];
}
